import { createApp } from 'vue';
import ChatWidget from './components/ChatWidget.vue';
import './css/style.css';

createApp(ChatWidget).mount('#app');